import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getPlatformList = createAsyncThunk(
  "get-platform",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("platform/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createPlatform = createAsyncThunk(
  "create-platform",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("platform", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editPlatform = createAsyncThunk(
  "edit-platform",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`platform/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updatePlatform = createAsyncThunk(
  "update-platform",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/platform/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deletePlatform = createAsyncThunk(
  "delete-platform",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/platform/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const platformSlice = createSlice({
  name: "platform",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlatformList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPlatformList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.platformList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getPlatformList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default platformSlice.reducer;
